"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InvalidStorageProvider = _interopRequireDefault(require("../Exceptions/InvalidStorageProvider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StorageInterface = concreteImplementation => {
  if (!concreteImplementation || typeof concreteImplementation !== 'object') {
    throw _InvalidStorageProvider.default.invalid();
  }

  const REQUIRED_PROPERTIES = ['get', 'set', 'remove', 'clear'];
  REQUIRED_PROPERTIES.forEach(property => {
    if (typeof concreteImplementation[property] === 'undefined') {
      throw _InvalidStorageProvider.default.missingProperty(property);
    }
  });
  return true;
};

var _default = StorageInterface;
exports.default = _default;